import { ZERO_FEES_CONFIG_BY_MARKET_INDEX } from 'src/constants/zeroFees';
import { extractStringValuesFromObject } from '@velocity-exchange/common';

interface PnlModalCardImagePathsByType {
	/**
	 * Images included in all cases.
	 */
	standard: string[];
	pnl: {
		position: {
			positive: string;
			negative: string;
		};
		portfolio: {
			positive: string;
			negative: string;
		};
	};
	zeroFees: {
		[marketIndex: number]: string | undefined;
	};
}

export const PNL_MODAL_CARD_IMAGE_PATHS_BY_TYPE: PnlModalCardImagePathsByType =
	{
		standard: ['/assets/images/pnl/pnl-rocket.webp'],
		pnl: {
			position: {
				positive: '/assets/images/pnl/pnl-drift-logo-up-2.webp',
				negative: '/assets/images/pnl/pnl-drift-logo-down-2.webp',
			},
			portfolio: {
				positive: '/assets/images/pnl/pnl-portfolio-drift-logo-up.webp',
				negative: '/assets/images/pnl/pnl-portfolio-drift-logo-down.webp',
			},
		},
		zeroFees: Object.fromEntries(
			Object.entries(ZERO_FEES_CONFIG_BY_MARKET_INDEX).map(
				([marketIndex, config]) => [marketIndex, config?.pnlModalCardImagePath]
			)
		),
	};

// Create an array of each nested path in the above object.
export const PNL_MODAL_CARD_IMAGE_PATHS = extractStringValuesFromObject(
	PNL_MODAL_CARD_IMAGE_PATHS_BY_TYPE
);

export const PNL_MODAL_MAX_COLLATERAL_DISPLAY_COUNT = 3;
